export default "__VITE_ASSET__CgMCcerD__"